import React, { useMemo } from 'react';

import BlockContainer from 'uicontainers/_shared/container/BlockContainer';
import { Props } from 'uicontainers/_shared/container/BlockContainer/types';

const CAT_MESSAGES = [
  'Something went wrong. The cats are on it.',
  "This page has gone to the dogs... wait, we mean cats.",
  "Our cats are investigating. Please try again later.",
  "Error: cat not found. (Just kidding — here's a cat.)",
  "Something broke. Have a cat while we fix it.",
];

const Error = () => {
  const { header, subContent, catImageUrl } = useMemo(() => {
    const message = CAT_MESSAGES[Math.floor(Math.random() * CAT_MESSAGES.length)];
    const catUrl = `https://cataas.com/cat?width=400&height=300&t=${Math.random()}`;
    return {
      header: message,
      subContent: `Looks like something unexpected happened. Please retry the link in 1 minute. If you have any
        additional issues or if that does not work, reply to the email and we will look into it.`,
      catImageUrl: catUrl,
    };
  }, []);

  const containerProps: Props = {
    header,
    subHeaders: [{ content: subContent }],
    image: {
      path: catImageUrl,
      altText: 'A cat',
    },
  };

  return <BlockContainer {...containerProps}></BlockContainer>;
};

export default Error;
